import { Component, computed, input } from '@angular/core';
import { TranslocoModule } from '@jsverse/transloco'; // cspell:disable-line
import { LucideAngularModule } from 'lucide-angular';
import { FormatCO2ePipe } from 'src/app/pipes/format-co2e.pipe';

/** Company objective compared to this trip's footprint per traveller. */
export interface ObjectiveTip {
  targetValue: number;
  tripValue: number;
  isAboveTarget: boolean;
  differencePercent: number;
}

@Component({
  selector: 'app-reduction-objective-card',
  standalone: true,
  imports: [TranslocoModule, LucideAngularModule, FormatCO2ePipe],
  templateUrl: './reduction-objective-card.component.html',
})
export class ReductionObjectiveCardComponent {
  objective = input.required<ObjectiveTip>();

  /** The bar is scaled so the highest of the two values never fills it. */
  private scale = computed(
    () =>
      Math.max(this.objective().tripValue, this.objective().targetValue) * 1.2,
  );

  barWidthPercent = computed(() =>
    Math.round((this.objective().tripValue / this.scale()) * 100),
  );

  markerPercent = computed(() =>
    Math.round((this.objective().targetValue / this.scale()) * 100),
  );

  barColorClass = computed(() => {
    const { isAboveTarget, differencePercent } = this.objective();
    if (!isAboveTarget) return 'bg-validation-500';
    return differencePercent <= 50 ? 'bg-warning-500' : 'bg-error-500';
  });

  statusTextClass = computed(() => {
    const { isAboveTarget, differencePercent } = this.objective();
    if (!isAboveTarget) return 'text-validation-600';
    return differencePercent <= 50 ? 'text-warning-600' : 'text-error-600';
  });
}
